import { pipe } from '@helo/utils'

import { Options } from '../../Options'
import { RenderPipeline } from '../../RenderPipeline'
import { ChartDataParts } from '../ChartData/ChartData.parts'
import type { ChartLegendSlice } from './ChartLegend'
import {
  type ChartLegendOrientation,
  type ChartLegendPosition,
  chartLegendOptions,
} from './ChartLegend.options'

const setLegend = () =>
  RenderPipeline.updateOutput(
    (
      _output: { legend?: ChartLegendSlice },
      ctx: {
        input: {
          _legend?: {
            visible?: boolean
            orientation?: ChartLegendOrientation
            position?: ChartLegendPosition
          }
          visible?: boolean
          orientation?: ChartLegendOrientation
          position?: ChartLegendPosition
        }
      },
    ) => {
      const legend = ctx.input._legend ?? ctx.input
      return {
        legend: {
          visible: legend.visible ?? ctx.input.visible ?? true,
          orientation:
            legend.orientation ?? ctx.input.orientation ?? 'horizontal',
          position: legend.position ?? ctx.input.position ?? 'top',
        },
      }
    },
  )

/** Resolve legend options from override, then content-node state. */
const setupInput = () =>
  RenderPipeline.updateInput((input, ctx) =>
    pipe(
      input,
      Options.fallback(chartLegendOptions, ChartDataParts.getChartState()(ctx)),
      Options.applyDefaults(chartLegendOptions),
      Options.validate(chartLegendOptions),
    ),
  )

/** Same resolution for `_legend`. */
const setup_legendInput = () =>
  RenderPipeline.updateInput((input, ctx) => ({
    ...input,
    _legend: pipe(
      input._legend ?? {},
      Options.fallback(
        chartLegendOptions,
        ChartDataParts.getNestedState('_legend')(ctx),
      ),
      Options.applyDefaults(chartLegendOptions),
    ),
  }))

export const ChartLegendInputParts = {
  setupInput,
  setup_legendInput,
}

export const ChartLegendOutputParts = {
  setLegend,
}
